import { useContext } from 'react';
import { DmsDispatchContext, DmsStateContext } from './dms.context';

export const useDmsState = () => {
    const state = useContext(DmsStateContext);

    if (state === undefined) {
        throw new Error('useDmsState must be used within a DmsProvider');
    }
    return state;
};

export const useDmsDispatch = () => {
    const dispatch = useContext(DmsDispatchContext);

    if (dispatch === undefined) {
        throw new Error('useDmsDispatch must be used within a DmsProvider');
    }
    return dispatch;
};
